export const GUEST_COUNT_SEARCH_PARAM = 'guestCount';
export const RESTAURANT_EVENT_TIER_ID = 'restaurantEventTierId';
export const SELECTED_FLOOR_PLAN_TABLE_ID = 'selectedFloorPlanTableId';
export const SELECTED_ADD_ONS = 'selectedAddOns';
export const LOW_INVENTORY_MAX_SPOTS = 9;
